@if (linked && unlinked) {
    <div class="link-page row" #page>
        <div class="linked-items col-6" [class.col-12]="!showLinkPanel">
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'externalConnections.controlLinkable.linkedTitle' | transloco: { typename: typename } }}</div>
                @if (showLinkPanel) {
                    <div class="form-group">
                        <div>
                            <div class="input-group">
                                @if (!hideFilter) {
                                    <input
                                        type="text"
                                        class="form-control"
                                        [placeholder]="'externalConnections.controlLinkable.filterPlaceholder' | transloco"
                                        (debounce-input-event)="filterText(true)"
                                        [(ngModel)]="filterTextLinked"
                                        inputTooltip
                                    />
                                }
                                <div class="input-group-append">
                                    <button
                                        type="button"
                                        class="btn btn-cerrix"
                                        (click)="toggleSelection(false)"
                                    >
                                    {{ 'externalConnections.controlLinkable.deselectAll' | transloco }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <cerrix-select-tree
                                [tree]="frameworkDimensionTree"
                                id="tpaWizardLinkedFD"
                                [multiselect]="true"
                                [maxLines]="2"
                                (onChangeIds)="filterFrameworkDimension($event, true)"
                            >
                            </cerrix-select-tree>
                        </div>
                    </div>
                }
                @if (linked.length > 0) {
                    <div class="detail-page-card-body">
                        <ul
                            class="list-group list-group-flush"
                            [sortablejs]="linked"
                            [sortablejsOptions]="sortingOptions"
                        >
                            @for (item of linkedPage; track item) {
                                <li class="list-group-item list-group-item-action py-2">
                                    <div class="d-flex w-100 justify-content-between">
                                        <h6
                                            class="text-truncate me-2 mb-0"
                                            [matTooltip]="item[displayValueProp]"
                                        >
                                            @if (
                                                item.displayItems && item.displayItems.length > 0
                                            ) {
                                                <i
                                                    (click)="
                                                        expandItem(item); $event.stopPropagation()
                                                    "
                                                    class="far fa-{{
                                                        item._isExpanded ? 'minus' : 'plus'
                                                    }}-square group-expander"
                                                ></i>
                                            }
                                            @if (useIcons) {
                                                <i class="{{ item.rowIcon }} ms-2 rowIcon"> </i>
                                            }
                                            {{ item[displayValueProp] }}
                                        </h6>
                                        <h6 class="group-item-actions mb-0">
                                            @if (!disabled && showLinkPanel) {
                                                <i
                                                    (click)="toggleItem(item, false, true)"
                                                    class="fas fa-arrow-right ms-2"
                                                ></i>
                                            }
                                        </h6>
                                    </div>
                                    @if (
                                        item._isExpanded &&
                                        item.displayItems &&
                                        item.displayItems.length > 0
                                    ) {
                                        <div class="item-expand">
                                            <table class="cerrix-table bordered-columns">
                                                <tbody>
                                                    @for (prop of item.displayItems; track prop) {
                                                        <tr>
                                                            <td>
                                                                <b>{{ prop.Header }}</b>
                                                            </td>
                                                            <td class="text-truncate">
                                                                <workspace-cell
                                                                    [configs]="rendererConfig"
                                                                    [row]="item.displayItemRow"
                                                                    [header]="prop.Header"
                                                                >
                                                                </workspace-cell>
                                                            </td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </li>
                            }
                        </ul>
                    </div>
                }

                <div class="detail-page-footer">
                    @if (!linkedPage || linkedPage.length === 0) {
                        <div class="list-empty-text">
                            @if (linked && linked.length > 0) {
                                <span>{{ 'externalConnections.controlLinkable.noMatchFilter' | transloco: { typename: typename } }}</span>
                            } @else {
                                <span>{{ 'externalConnections.controlLinkable.noLinkedItems' | transloco: { typename: typename } }}</span>
                            }
                        </div>
                    }
                    @if (linked.length > 0 && linkedPaginationPageCount > 1) {
                        <div class="pagination justify-content-center">
                            <ul class="pagination">
                                <li class="page-item" [class.disabled]="linkedPaginationPage == 0">
                                    <span
                                        class="page-link"
                                        (click)="setPaginationPage(linkedPaginationPage - 1, true)"
                                    >
                                        {{ 'externalConnections.controlLinkable.previousPage' | transloco }}
                                    </span>
                                </li>

                                <li class="page-item disabled">
                                    <span class="page-link">{{ linkedPaginationText }}</span>
                                </li>

                                <li
                                    class="page-item"
                                    [class.disabled]="
                                        linkedPaginationPage >= linkedPaginationPageCount - 1
                                    "
                                >
                                    <span
                                        class="page-link"
                                        (click)="setPaginationPage(linkedPaginationPage + 1, true)"
                                    >
                                        {{ 'externalConnections.controlLinkable.nextPage' | transloco }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="linkable-items col-6" [hidden]="!showLinkPanel">
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'externalConnections.controlLinkable.linkableTitle' | transloco: { typename: typename } }}</div>
                <div class="form-group">
                    <div>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button
                                    type="button"
                                    class="btn btn-cerrix"
                                    (click)="toggleSelection(true)"
                                >
                                    {{ 'externalConnections.controlLinkable.selectAll' | transloco }}
                                </button>
                            </div>
                            @if (!hideFilter) {
                                <input
                                    type="text"
                                    class="form-control"
                                    [placeholder]="'externalConnections.controlLinkable.filterPlaceholder' | transloco"
                                    (debounce-input-event)="filterText(false)"
                                    [(ngModel)]="filterTextUnlinked"
                                    inputTooltip
                                />
                            }
                        </div>
                    </div>

                    <div>
                        <cerrix-select-tree
                            [tree]="frameworkDimensionTree"
                            id="tpaWizardUnlinkedFD"
                            [multiselect]="true"
                            [maxLines]="2"
                            (onChangeIds)="filterFrameworkDimension($event, false)"
                            [value]="selectedFdIdUnlinked"
                        >
                        </cerrix-select-tree>
                    </div>
                </div>
                <div class="detail-page-card-body">
                    <ul
                        class="list-group list-group-flush"
                        [sortablejs]="unlinked"
                        [sortablejsOptions]="sortingOptions"
                    >
                        @for (item of linkablePage; track item) {
                            <li class="list-group-item list-group-item-action py-2">
                                <div class="d-flex w-100 justify-content-between">
                                    <h6
                                        class="text-truncate me-2 mb-0"
                                        [matTooltip]="item[displayValueProp]"
                                    >
                                        <i
                                            class="fas fa-arrow-left me-2"
                                            (click)="toggleItem(item, true, true)"
                                        ></i>
                                        @if (item.displayItems && item.displayItems.length > 0) {
                                            <i
                                                (click)="expandItem(item); $event.stopPropagation()"
                                                class="far fa-{{
                                                    item._isExpanded ? 'minus' : 'plus'
                                                }}-square group-expander"
                                            ></i>
                                        }
                                        @if (useIcons) {
                                            <i class="{{ item.rowIcon }} ms-2 rowIcon"> </i>
                                        }
                                        {{ item[displayValueProp] }}
                                    </h6>
                                </div>
                                @if (
                                    item._isExpanded &&
                                    item.displayItems &&
                                    item.displayItems.length > 0
                                ) {
                                    <div class="item-expand">
                                        <table class="cerrix-table bordered-columns">
                                            <tbody>
                                                @for (prop of item.displayItems; track prop) {
                                                    <tr>
                                                        <td>
                                                            <b>{{ prop.Header }}</b>
                                                        </td>
                                                        <td class="text-truncate">
                                                            <workspace-cell
                                                                [configs]="rendererConfig"
                                                                [row]="item.displayItemRow"
                                                                [header]="prop.Header"
                                                            >
                                                            </workspace-cell>
                                                        </td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </li>
                        }
                    </ul>
                </div>

                <div class="detail-page-footer">
                    @if (!linkablePage || linkablePage.length === 0) {
                        <div class="list-empty-text">
                            @if (unlinked && unlinked.length > 0) {
                                <span>{{ 'externalConnections.controlLinkable.noMatchFilter' | transloco: { typename: typename } }}</span>
                            } @else {
                                <span>{{ 'externalConnections.controlLinkable.noItemsToLink' | transloco: { typename: typename } }}</span>
                            }
                        </div>
                    }
                    @if (unlinked.length > 0 && linkablePaginationPageCount > 1) {
                        <div class="pagination justify-content-center">
                            <ul class="pagination">
                                <li
                                    class="page-item"
                                    [class.disabled]="linkablePaginationPage == 0"
                                >
                                    <span
                                        class="page-link"
                                        (click)="
                                            setPaginationPage(linkablePaginationPage - 1, false)
                                        "
                                    >
                                        {{ 'externalConnections.controlLinkable.previousPage' | transloco }}
                                    </span>
                                </li>

                                <li class="page-item disabled">
                                    <span class="page-link">{{ linkablePaginationText }}</span>
                                </li>

                                <li
                                    class="page-item"
                                    [class.disabled]="
                                        linkablePaginationPage >= linkablePaginationPageCount - 1
                                    "
                                >
                                    <span
                                        class="page-link"
                                        (click)="
                                            setPaginationPage(linkablePaginationPage + 1, false)
                                        "
                                    >
                                        {{ 'externalConnections.controlLinkable.nextPage' | transloco }}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
